<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      usuarioLogado: null,
      processosArrecadacao: [],
      totalCadastros: 0
    }
  },

  methods: {
    ...mapActions({
      findProcessosCadastrados: 'processoArrecadacao/find'
    }),
    ...mapGetters({
      getUsuario: 'auth/usuarioLogado'
    }),

    executar (item) {
      this[item.acao](this, item)
    },

    async init () {
      this.usuarioLogado = await this.getUsuario()
      this.filtro = {
        ...this.filtro,
        perfil: this.usuarioLogado.perfilSelecionado.codigo,
        setor: this.usuarioLogado.perfilSelecionado.setor.codigo
      }
      const {
        processosArrecadacao,
        total
      } = await this.findProcessosCadastrados(this.filtro)
      this.processosArrecadacao = processosArrecadacao
      this.totalCadastros = total
    },

    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }
      this.init()
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.changePage(1)
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.filtro.simplificado = true
      this.init()
    },

    formatMunicipio (row, column, prop) {
      if (prop) {
        return prop?.length === 0 ? '-' : prop[0].nome
      }

      return '-'
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.init()
    }
  },

  computed: {
    pagina () {
      return this.filtro.pagina + 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/mixins/BaseFiltroArrecadacao.vue